/**
 * The third-party communication providers primary integrates with. primary owns this vocabulary —
 * its communication vendor account record stores the vendor, and a phone number capability reports
 * which one manages it.
 */
export var CommunicationVendor;
(function (CommunicationVendor) {
    CommunicationVendor["Twilio"] = "Twilio";
    CommunicationVendor["Vapi"] = "Vapi";
})(CommunicationVendor || (CommunicationVendor = {}));
//# sourceMappingURL=communicationVendor.js.map